function createListingGallery(card) {
  const images = card.querySelectorAll("img");
  const overlay = document.createElement("div");
  overlay.classList.add("listing-gallery__overlay", "overlay");
  card.append(overlay);
  const bullets = document.createElement("div");
  bullets.classList.add("listing-gallery__bullets");
  card.append(bullets);

  images.forEach((image, i) => {
    image.setAttribute("data-index", i);

    const imageTrigger = document.createElement("a");
    imageTrigger.classList.add("overlay__link");
    imageTrigger.addEventListener("mouseover", () => {
      show(i);
    });
    overlay.append(imageTrigger);

    const bullet = document.createElement("div");
    bullet.classList.add("bullet");
    if (i === 0) bullet.classList.add("active");
    bullets.append(bullet);
  });
  const show = (idx) => {
    images.forEach((image, i) => {
      image.classList.toggle("hidden", i !== idx);
    });
    const bulletItems = bullets.querySelectorAll(".bullet");
    bulletItems.forEach((bullet, i) => {
      bullet.classList.toggle("active", i === idx);
    });
  };
}

document.addEventListener("DOMContentLoaded", () => {
  const listingItems = document.querySelectorAll("[data-listing-gallery]");
  listingItems.forEach((item) => {
    createListingGallery(item);
  });
});
